import { gql } from "@grandvisionhq/graphql";
import { cartDetails } from "../../../fragments/operations/fragments/cart-details.js";
import { cartValidationErrors } from "../../../fragments/operations/fragments/cart-validation-errors.js";
const UPDATE_CART_LINE_ITEMS = gql`
  mutation UpdateCartLineItems($cartInput: UpdateCartLineItemsInput!) {
    updateCartLineItems(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;
export {
  UPDATE_CART_LINE_ITEMS
};
//# sourceMappingURL=update-cart-line-items.js.map
